import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import LandingNav from "../components/LandingNav";
import Navbar from "../components/Navbar";

export default function HomePage() {
    let navigate = useNavigate(); 
    const routeChangeJob = () =>{ 
      let path = `/`; 
      navigate(path);
      window.location.reload();
    }

    return (
        <div className="flex flex-col min-h-screen">
            <LandingNav />

            <main className="flex-grow">
            <section className="hero bg-neutral bg-cover bg-center bg-no-repeat">
    <div className="hero min-h-screen" style={{ backgroundImage: "url(purp.jpg)" }}>
      <div className="hero-content flex-col lg:flex-row-reverse">
        <div className="flex flex-col items-end mr-5">
          <img src="pic1.png" className="max-w-xl rounded-lg shadow-2xl mb-4 animate-bounce-in" />
          <img src="pic2.png" className="max-w-xl rounded-lg shadow-2xl mb-4 animate-bounce-in" />
          <img src="pic3.png" className="max-w-xl rounded-lg shadow-2xl animate-bounce-in" />
        </div>
        <div className="text-left animate-bounce-in">
          <h1 className="text-5xl font-bold">Find Top Software Developers</h1>
          <p className="py-6">GigEship is the ultimate platform for connecting college students with innovative business ideas to talented software developers who can bring those ideas to life.</p>
          <button className="btn btn-primary" onClick={routeChangeJob}>Get Started</button>
        </div>
      </div>
    </div>
  </section>



                <section className="bg-neutral pt-20 pb-10">
                    <div className="container mx-auto">
                        <h2 className="text-4xl font-bold text-center mb-6">How Gigeship Works</h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                            <div className="p-4 bg-secondary rounded-lg shadow">
                                <h3 className="text-2xl font-bold mb-4">Post Your Project</h3>
                                <p>Share your business idea and project details with us. Let the software developers know what you need.</p>
                            </div>
                            <div className="p-4 bg-secondary rounded-lg shadow">
                                <h3 className="text-2xl font-bold mb-4">Connect with Developers</h3>
                                <p>Qualified software developers interested in your project will reach out to you. Review their profiles and connect with them.</p>
                            </div>
                            <div className="p-4 bg-secondary rounded-lg shadow">
                                <h3 className="text-2xl font-bold mb-4">Develop Your Idea</h3>
                                <p>Collaborate with the chosen developer to bring your business idea to life. Work together and make progress.</p>
                            </div>
                            <div className="p-4 bg-secondary rounded-lg shadow">
                                <h3 className="text-2xl font-bold mb-4">Launch Your Startup</h3>
                                <p>Once your project is developed, launch your startup and make it a reality. Take your business to the next level.</p>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="bg-neutral pb-20">
                    <div className="container mx-auto">
                        <h2 className="text-4xl font-bold text-center mb-6">Why Choose Gigeship</h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                            <div className="p-4 bg-secondary rounded-lg shadow">
                                <h3 className="text-2xl font-bold mb-4">Student-Focused Platform</h3>
                                <p>Gigeship is built by college students for college students. We understand your needs and provide a platform tailored to you.</p>
                            </div>
                            <div className="p-4 bg-secondary rounded-lg shadow">
                                <h3 className="text-2xl font-bold mb-4">Access to Talented Developers</h3>
                                <p>Find talented software developers who are eager to work on innovative projects and bring your ideas to life.</p>
                            </div>
                            <div className="p-4 bg-secondary rounded-lg shadow">
                                <h3 className="text-2xl font-bold mb-4">Collaborative Environment</h3>
                                <p>Gigeship fosters a collaborative environment where you can work closely with developers and turn your ideas into reality.</p>
                            </div>
                            <div className="p-4 bg-secondary rounded-lg shadow">
                                <h3 className="text-2xl font-bold mb-4">Launch Your Startup</h3>
                                <p>With Gigeship, you have the opportunity to launch your startup and take your business to the next level.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}

